<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div class="brief-form">
          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
            v-for="checkbox in squareInputs"
            :key="checkbox.name"
          >
            <input
              class=""
              :id="checkbox.name"
              type="checkbox"
              :name="checkbox.name"
              :value="checkbox.value"
              v-model.trim="form.siteMaterials"
              @input="manageOptions"
            />
            <label :for="checkbox.name" class="form__label">{{
              checkbox.label
            }}</label>
          </div>
          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
          >
            <input
              class=""
              id="mfp-other"
              type="checkbox"
              name="mfp-other"
              value="Inne"
              :checked="hasDescription"
              @input="invokeTouch($v.form.siteMaterials)"
              @click="otherHandler"
            />
            <label for="mfp-other" class="form__label">Inne</label>
          </div>
          <transition name="fade-input">
            <div
              v-if="hasDescription"
              class="form__input-wrapper"
              :class="{ error: $v.form.siteOtherMaterials.$anyError }"
            >
              <label for="siteOtherMaterials" class="form__label uk-hidden"
                >Podaj inne</label
              >
              <input
                class="form-input uk-width-1-1"
                id="siteOtherMaterials"
                type="text"
                name="siteOtherMaterials"
                ref="otherInput"
                @input="event => delayTouchCounterComposition($v.form, 'siteOtherMaterials', event.target.value)"
              />
              <span class="form__error-message form__error-message--no-label">
                <template v-if="!$v.form.siteOtherMaterials.minLength">
                  {{ validationMessage.minLength }}</template
                >
                <template v-if="!$v.form.siteOtherMaterials.required">
                  {{ validationMessage.required }}</template
                >
              </span>
            </div>
          </transition>

          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
            v-for="checkbox in circleInputs"
            :key="checkbox.name"
          >
            <input
              class=""
              :id="checkbox.name"
              type="checkbox"
              :name="checkbox.name"
              :value="checkbox.value"
              v-model.trim="form.siteMaterials"
              @input="manageOptions"
            />
            <label :for="checkbox.name" class="form__label circle-check">{{
              checkbox.label
            }}</label>
          </div>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'MaterialsForPage',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Projekt bez contentu jest jak pączek bez nadzienia. '
      + 'Jakimi materiałami do wykorzystania na stronie dysponujesz?',
    form: {
      siteMaterials: [],
      siteOtherMaterials: '',
    },
    hasDescription: false,
    formCheckboxes: [
      {
        name: 'mfp-content',
        value: 'treść',
        label: 'treść',
      },
      {
        name: 'mfp-pictures',
        value: 'zdjęcia',
        label: 'zdjęcia',
      },
      {
        name: 'mfp-video',
        value: 'wideo',
        label: 'wideo',
      },
      {
        name: 'mfp-no',
        value: 'nie posiadam',
        label: 'nie posiadam',
      },
    ],
  }),

  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          siteMaterials: {
            required,
          },
        },
      };
    }
    return {
      form: {
        siteMaterials: {},
        siteOtherMaterials: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  computed: {
    squareInputs() {
      return this.formCheckboxes.filter((checkbox)=>{
        return checkbox.name !== 'mfp-no';
      });
    },
    circleInputs() {
      return this.formCheckboxes.filter((checkbox)=>{
        return checkbox.name === 'mfp-no';
      });
    }
  },
  methods: {
    otherHandler() {
      this.hasDescription = !this.hasDescription;

      if (!this.hasDescription) {
        this.form.siteOtherMaterials = '';
      } else {
        this.form.siteMaterials = this.form.siteMaterials.filter((el) => el !== 'nie posiadam');
        setTimeout(() => {
          this.$refs.otherInput.focus();
        }, 100);
      }
    },

    manageOptions(e) {
      if (e.target.value === 'nie posiadam') {
        this.form.siteMaterials = [e.target.value];
        if (this.hasDescription) {
          this.otherHandler();
        }
      } else {
        this.form.siteMaterials = this.form.siteMaterials.filter((el) => el !== 'nie posiadam');
      }
      this.invokeTouch(this.$v.form.siteMaterials);
    },
  },
};
</script>
